<template>
  <div>
    <section class="banner">
      <v-layout column align-center justify-center class="banner-bottom">
        <div class="familiacantu white--text text-xs-center">Família Cantu</div>
        <div class="brasil white--text text-xs-center">NO BRASIL</div>
        <img src="/static/img/Ativo 10@4x.png" alt="FAMILIA CANTU" width="400" height="25">
      </v-layout>
    </section>

    <section class="banner3">
      <v-layout
        column
        wrap
        class="mt-5 ml-5 mr-5"
        align-center
      >
        <v-flex xs12 sm4 class="mt-3 ml-3 mr-3">
          <v-layout column align-center justify-center>
            <div class="historia text-xs-center">HISTÓRIA</div>
            <hr class="historiahr">
            <v-layout wrap mt-5 align-center>
              <v-flex xs12 sm8 offset-sm2>
                
                <v-layout wrap align-center>
                  <v-flex xs12 >
                    <v-card-text class="text-xs-center text-historia">
                      <p>Um pouco de história….</p>
                      <p>No século XIX, a Itália, assim como grande parte da Europa, estava em ebulição. A Itália era um amontoado de estados independentes. Depois de trinta anos e várias tentativas, a unificação acontece e o novo reino entra numa profunda crise. O trabalho desaparece e a economia entra em colapso.</p>
                      <p>É neste cenário que temos de imaginar o Domênico, o patriarca da família Cantú aqui no Brasil. Somado a isso, em Dezembro de 1881, morre seu pai Giovanni Maria, com 73 anos. Em seguida (38 dias após), em Janeiro de 1882, morre sua filha Maria Giuseppa (a quarta e última do casal), com 5 meses de idade. Nesta época, ainda estavam residindo em Antegnate,  (Via Sto Ambroasio, 15), Bérgamo, Itália.</p>
                      <p>Com certeza, esta situação, aliada ao contexto do país, impulsionou a família a emigrar. Eram Domênico, a esposa Maria Valéria Podavite e os três filhos: Lúcia, Giovanni Maria e Pietro Sílvio.</p>
                      <p>E, mal sabia Domênico que a partir desta sua decisão dava início a grande família Cantú no Brasil. Destes cinco pioneiros, nestes 120 anos, estima-se que nasceram mais de 1500 descendentes, hoje espalhados por todo país.</p>
                      <p v-html="model.card1"></p>
                    </v-card-text>
                  </v-flex> 
                  <v-flex xs12 >
                    <div v-for="item in model.images"
                      :key="item">
                      <img style="margin-left: 50px;"  :src="item.image" alt="FAMILIA CANTU" height="250">
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
             
            </v-layout>
           
            
          </v-layout>
        </v-flex>
      </v-layout>
    </section>
  </div>
</template>

<script>
import store from "../store";
import parameter from "@/services/parameter";

export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Hello ' + this.$store.state.world,
      server: this.$store.getters.server,
      model: {card1: ""},
      descontos: [],
      message: "",
      dialog: false,
      dialogError: false,
      dialogConfirmation: false,
    }
  },
  created() {
    parameter.getParameter().then(res => {
      this.model = res;
      this.model.card1 = this.model.card1.replace(/(?:\r\n|\r|\n)/g, '<br>');
    });
  },
  methods: {
    
    sair () {
      this.$router.push('/logout');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .banner {
    background-image: url('/static/img/Ativo 14@4x.png');
    background-repeat: no-repeat;
    background-position: left top;
    background-size: 100% 850px;
    max-height: 100%;
    height: 260px;
    min-height: 260px;
    width: 100%;
    padding-top: 100px;
    position:relative; 
  }
  .brasil {
    font-size: 30px;
    font-family: 'TrajanPro3-Regular', sans-serif !important;
  }
  .historia {
    height: 60px;
    font-size: 50px;
    color: #a56d30;
    font-family: 'TrajanPro3-Regular', sans-serif !important;
  }
  .historiahr {
    width: 200px;
    border: 0; border-top: 1px solid #a56d30;
  }
  .familiacantu {
    height: 60px;
    widows: 220px;
    font-size: 60px;
    font-family: 'marguerite', sans-serif !important;
  }
  .text-historia {
    font-size: 13px;
    font-weight: 500;
    text-align: justify;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Historia.vue